<template>
  <div class="strategy" data-testid="about-strategy">
    <div>
      <Heading :level="2">Estratégia</Heading>
      <div class="strategy__description">
        <SkeletonLoader v-if="isLoading">
          <div
            v-for="index in 5"
            :key="index"
            class="strategy__description--loader"
          />
        </SkeletonLoader>
        <BaseText v-else size="md" :color="NebraskaColors.elementSecondary">
          {{ strategy.description }}
        </BaseText>
      </div>
    </div>
    <div class="strategy__risk">
      <ContentDisplayLoader
        v-if="isLoading"
        class="strategy__content-display"
        has-button
      >
        <SkeletonLoader>
          <div class="strategy__risk__title--loader" />
          <div class="strategy__risk__subtitle--loader" />
        </SkeletonLoader>
      </ContentDisplayLoader>
      <ContentDisplay
        v-else
        class="strategy__content-display"
        footer-type="navigation"
        :blocks-length="1"
        :footer-label="riskProfile.buttonLabel"
        :footer-href="riskProfileHref"
        :line-color="NebraskaColors.riskHigh"
      >
        <template #content-block-1>
          <Heading class="strategy__risk__title" :level="4">{{
            riskProfile.portfolioRiskProfile.formatted
          }}</Heading>
          <BaseText size="xs" :color="NebraskaColors.elementSecondary">{{
            riskProfile.portfolioRiskProfile.description
          }}</BaseText>
        </template>
      </ContentDisplay>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import {
  BaseText,
  Heading,
  ContentDisplay,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { ContentDisplayLoader } from '@/modules/trade/components/ContentDisplayLoader';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  PortfolioStrategy,
  PortfolioRiskProfile
} from '@/modules/wealth/services/portfolio';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';

interface Props {
  strategy?: PortfolioStrategy;
  riskProfile?: PortfolioRiskProfile;
  isLoading: boolean;
}
defineProps<Props>();

const riskProfileHref = computed(() => {
  const { domain } = getDomainAndPlatform();

  return `/onboarding/${domain}/desktop/suitability/user-profile`;
});
</script>

<style lang="less" scoped>
.strategy {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: @size-spacing-x600;

  .to-md({
    grid-template-columns: 1fr;
  });

  &__description {
    margin-top: @size-spacing-x400;

    &--loader {
      height: 22px;
      width: 100%;
      border-radius: @size-radius-x100;
      margin-bottom: @size-spacing-x150;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__risk {
    display: flex;
    align-items: flex-end;

    &__title {
      margin-bottom: @size-spacing-x150;

      &--loader {
        height: 28px;
        margin-bottom: @size-spacing-x150;
        width: 40%;
        border-radius: @size-radius-x100;
      }
    }

    &__subtitle {
      &--loader {
        height: 18px;
        width: 70%;
        border-radius: @size-radius-x100;
      }
    }
  }

  &__content-display {
    width: 100%;
  }
}
</style>
